/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const AmericanExpress = (props: IconProps) => (
  <Icon {...props}>

    <path
      d="M1.5 3.002h21c.828 0 1.5.701 1.5 1.566v14.869c0 .864-.672 1.565-1.5 1.565h-21c-.829 0-1.5-.701-1.5-1.565V4.568c0-.865.672-1.566 1.5-1.566z"
    />
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M3.867 9l-2.368 5.24h2.835l.351-.835h.804l.351.836h3.12v-.638l.279.638h1.614l.278-.652v.652h6.49l.789-.814.739.814 3.333.006-2.376-2.612L22.482 9H19.2l-.768.799L17.716 9h-7.06l-.606 1.353L9.43 9H6.6v.616L6.287 9h-2.42zm.548.744h1.382l1.571 3.554V9.744h1.514l1.213 2.548 1.118-2.548h1.507v3.76h-.917l-.007-2.946-1.337 2.947h-.82l-1.343-2.947v2.947H6.41l-.357-.843H4.122l-.357.842h-1.01l1.66-3.76zm9.143 0h3.727l1.14 1.231 1.176-1.23h1.14l-1.732 1.89 1.732 1.867h-1.192l-1.14-1.245-1.182 1.245h-3.669V9.744zm-8.47.636l-.637 1.502h1.272l-.635-1.502zm9.39.143v.686h2.033v.765h-2.033v.75h2.28l1.06-1.104-1.014-1.098h-2.326z"
    />

  </Icon>
);
